import { PrinterOutlined, SyncOutlined } from "@ant-design/icons";
import axiosInstance from "../../../shared/axios";
import { ReadyToPrint } from "../ReadyToPrint";
import {
  Modal,
  Button,
  Spin,
  message,
  Typography,
  Divider,
  Space,
  Flex,
} from "antd";
import { HairForm } from "./azeem";
import { useState, useEffect, useRef } from "react";
import { services as api } from "../../../services";
import { clientapi } from "../../../services/clientsapi";
import { PrintMedicalHistory } from "./PrintMedicalHistory";

const PrintForm = ({ state, clientInfo }) => {
  return <PrintMedicalHistory state={state} clientinfo={clientInfo} />;
};
const { Title } = Typography;
const MedicalHistory = ({ visible, clientId, onClose, clientInfo }) => {
  const print = useRef();
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [isExistingHistory, setIsExistingHistory] = useState(false);

  const clickOnPrint = () => {
    if (print.current) {
      print.current();
    }
  };

  useEffect(() => {
    if (visible && clientId) {
      fetchMedicalHistory();
    } else if (visible) {
      setState({});
      setIsExistingHistory(false);
    }
  }, [visible, clientId]);

  const fetchMedicalHistory = async () => {
    if (!clientId) return;

    setLoading(true);
    try {
      const result = await clientapi?.getMedicalHistoryByClientId(clientId);
      if (result) {
        setState(result);
        setIsExistingHistory(true);
      } else {
        message.info("No medical history found. You can create one now.");
        setState({});
        setIsExistingHistory(false);
      }
    } catch (error) {
      message.error("Failed to load medical history.");
      setState({});
      setIsExistingHistory(false);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const saveUpdateMedicalHistory = async () => {
    setLoading(true);
    const payload = {
      ...state,
    };
    const result = await api?.clientapi?.MedicalHistoryAddUpdateClient(
      state,
      clientId,
    );

    if (result?.success) {
      message.success(
        `Medical history ${clientId ? "updated" : "saved"} successfully!`,
      );
      onClose();
    } else {
      message.error(
        result?.message ||
          `Failed to ${clientId ? "update" : "save"} medical history of client`,
      );
    }
    setLoading(false);
  };

  return (
    <Modal
      title={<Title level={4}>Medical History</Title>}
      open={visible}
      onCancel={onClose}
      width={900}
      centered
      footer={null}
    >
      {loading ? (
        <Flex justify="center" align="center" style={{ height: "200px" }}>
          <Spin
            size="large"
            indicator={
              <SyncOutlined
                spin
                style={{ color: "var(--main-color)", fontSize: "24px" }}
              />
            }
          />
        </Flex>
      ) : (
        <>
          <HairForm state={state} handleChange={handleChange} />
          <Divider />
          <div style={{ textAlign: "right" }}>
            <Space size={12}>
              <Button
                style={{ background: "#2F80ED" }}
                className="text-white border-0"
                icon={<PrinterOutlined />}
                onClick={clickOnPrint}
              >
                Print Medical History
              </Button>
              <Button
                type="primary"
                onClick={saveUpdateMedicalHistory}
                loading={loading}
                style={{ background: "#7FB691" }}
              >
                {isExistingHistory ? "Update" : "Save"} Medical History
              </Button>
            </Space>
          </div>

          <div style={{ display: "none" }}>
            <ReadyToPrint
              name="Medical History"
              print={print}
              Component={
                <div>
                  <PrintForm state={state} clientInfo={clientInfo} />
                </div>
              }
            />
          </div>
        </>
      )}
    </Modal>
  );
};

export default MedicalHistory;
